// Global toast instance for utility classes and non-component usage
// This is a bridge solution until all components can use the useToast hook

let globalToastInstance: {
  success: (message: string) => void;
  error: (message: string) => void;
  warning: (message: string) => void;
  info: (message: string) => void;
} | null = null;

export const setGlobalToastInstance = (instance: {
  success: (message: string) => void;
  error: (message: string) => void;
  warning: (message: string) => void;
  info: (message: string) => void;
}) => {
  globalToastInstance = instance;
};

export const toast = {
  success: (message: string) => {
    if (globalToastInstance) {
      globalToastInstance.success(message);
    } else {
      console.warn('Toast not initialized. Message:', message);
    }
  },
  error: (message: string) => {
    if (globalToastInstance) {
      globalToastInstance.error(message);
    } else {
      console.warn('Toast not initialized. Message:', message);
    }
  },
  warning: (message: string) => {
    if (globalToastInstance) {
      globalToastInstance.warning(message);
    } else {
      console.warn('Toast not initialized. Message:', message);
    }
  },
  info: (message: string) => {
    if (globalToastInstance) {
      globalToastInstance.info(message);
    } else {
      console.warn('Toast not initialized. Message:', message);
    }
  },
};